import RSelect from 'react-select';
import styled, { css } from 'styled-components';
import media from 'themes/media';
import { prop } from 'styled-tools';

const isLink = (props) => props.type === 'link';

const MySelect = styled(RSelect).attrs((props) => ({
  classNamePrefix: 'rwSelect',
}))`
  font-size: ${(props) => (isLink(props) ? '14px' : '12px')};

  text-transform: ${(props) => (props.noUppercase ? 'auto' : 'uppercase')};
  min-width: 80px;
  width: 100%;
  .rwSelect__value-container {
    height: 100%;
    ${(props) => props.noMargin
      && css`
        margin: 0;
      `}
    ${(props) => props.noPadding
      && css`
        padding: 0;
      `}
  }
  .rwSelect__control {
    height: 34px;
    border: 1px solid ${(props) => (isLink(props) ? 'transparent' : '#e8ebf2')};
    background: ${(props) => (isLink(props) ? 'transparent' : 'white')};
    ${media.greaterThan('tablet')`
      height: 42px;
    `}

    :hover {
      border-color: #2d9cdb;
    }
  }

  .rwSelect__option {
    color: #7e8eaa;
  }

  .rwSelect__menu {
    z-index: 888;
  }

  .rwSelect__option--is-selected {
    //background: transparent;
    color: #2d9cdb;
  }

  .rwSelect__option--is-focused {
    color: #2d9cdb;
    background: #edf6fa;
    cursor: pointer;
  }

  .rwSelect__option--is-selected,
  .rwSelect__single-value {
    color: ${(props) => (isLink(props) ? '#2D9CDB;' : '#303742')};

    /* @media (max-width: 680px) {
      font-size: 14px;
    } */
  }
  .rwSelect__indicator {
    color: ${(props) => (isLink(props) ? '#2D9CDB;' : '#e8ebf2')};
  }

  .rwSelect__indicator-separator {
    display: none;
  }
  ${(props) => props.isDark
    && css`
      .rwSelect__control {
        border-color: #173051;
        background: #051932;
        color: #7e8eaa;
      }
      .rwSelect__input {
        color: #7e8eaa;
      }
      .rwSelect__menu {
        background: #051932;
      }
      .rwSelect__option--is-selected,
      .rwSelect__single-value {
        color: #fff;
      }
      .rwSelect__option--is-focused {
        background: #173051;
        color: #2d9cdb;
      }
    `}
`;

export default MySelect;

export const CommonSelect = styled(RSelect).attrs((props) => ({
  classNamePrefix: 'rwSelect',
}))`
  font-size: ${(props) => (isLink(props) ? '14px' : '12px')};

  text-transform: ${(props) => (props.noUppercase ? 'auto' : 'uppercase')};
  min-width: 80px;
  width: 100%;
  .rwSelect__control {
    height: 34px;
    border: 1px solid ${(props) => (isLink(props) ? 'transparent' : '#e8ebf2')};
    background: ${(props) => (isLink(props) ? 'transparent' : 'white')};
    ${media.greaterThan('tablet')`
      height: 42px;
    `}

    :hover {
      border-color: #2d9cdb;
    }
  }

  .rwSelect__option {
    color: #7e8eaa;
  }

  .rwSelect__menu {
    z-index: 888;
  }

  .rwSelect__option--is-selected {
    background: transparent;
    color: #303742;
  }

  .rwSelect__option--is-focused {
    color: #2d9cdb;
    background: #edf6fa;
    cursor: pointer;
  }

  .rwSelect__option--is-selected,
  .rwSelect__single-value {
    color: ${(props) => (isLink(props) ? '#2D9CDB;' : '#303742')};
  }
  .rwSelect__indicator {
    color: ${(props) => (isLink(props) ? '#2D9CDB;' : '#e8ebf2')};
  }

  .rwSelect__indicator-separator {
    display: none;
  }
  ${(props) => props.isDark
    && css`
      .rwSelect__control {
        border-color: #173051;
        background: #051932;
        // background: #013765;
        color: #7e8eaa;
      }
      .rwSelect__input {
        color: #7e8eaa;
      }
      .rwSelect__menu {
        background: #051932;
      }
      .rwSelect__option--is-selected,
      .rwSelect__single-value {
        color: #fff;
      }
      .rwSelect__option--is-focused {
        background: #173051;
        color: #2d9cdb;
      }
    `}
`;

export const Select = styled(MySelect)`
  width: 50%;

  .rwSelect__control {
    width: 100%;
    height: 35px;
    border-radius: 35px;
    box-shadow: 0 0 6px 0 rgb(0 0 0 / 9%);
  }

  .rwSelect__single-value {
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #7e8eaa;
  }
  .rwSelect__value-container {
    padding: 2px 18px;
  }

  & + & {
    margin-left: 15px;
  }
`;
